<proffeo-task-view-settings
  (groupToggled)="toggleGroup($event)"
  (settingChanged)="updateSetting($event)"
  [groupEnabled]="groupEnabled()"
  [labelKey]="'task-list-view-settings.title'"
  [sections]="sections"
  [values]="values()"
/>
